/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it
import "./src/styles/typography.css"
import "./src/styles/global.css"
import "./src/styles/prism.css"

require("prismjs")
require("prismjs/themes/prism-twilight.css")
